import { CALL_API } from "admin/middlewares/api";

export const CREDIT_APPLICATION_EXPIRE_REQUEST =
  "CREDIT_APPLICATION_EXPIRE_REQUEST";
export const CREDIT_APPLICATION_EXPIRE_SUCCESS =
  "CREDIT_APPLICATION_EXPIRE_SUCCESS";
export const CREDIT_APPLICATION_EXPIRE_ERROR =
  "CREDIT_APPLICATION_EXPIRE_ERROR";

export function expire_application(appId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/credit-application/expire-application",
      method: "POST",
      data: { ApplicationId: appId },
      authenticatedRequest: true,
      types: [
        CREDIT_APPLICATION_EXPIRE_REQUEST,
        {
          method: RefreshCreditApplicationList.bind(
            this,
            CREDIT_APPLICATION_EXPIRE_SUCCESS,
          ),
        },
        CREDIT_APPLICATION_EXPIRE_ERROR,
      ],
    },
  };
}

export const CREDIT_APPLICATION_REJECT_REQUEST =
  "CREDIT_APPLICATION_REJECT_REQUEST";
export const CREDIT_APPLICATION_REJECT_SUCCESS =
  "CREDIT_APPLICATION_REJECT_SUCCESS";
export const CREDIT_APPLICATION_REJECT_ERROR =
  "CREDIT_APPLICATION_REJECT_ERROR";

export function reject_credit_offer(offerId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/credit-application/reject",
      method: "POST",
      data: { OfferId: offerId },
      authenticatedRequest: true,
      types: [
        CREDIT_APPLICATION_REJECT_REQUEST,
        {
          method: RefreshCreditApplicationList.bind(
            this,
            CREDIT_APPLICATION_REJECT_SUCCESS,
          ),
        },
        CREDIT_APPLICATION_REJECT_ERROR,
      ],
    },
  };
}

export const APPLICATION_LIST_GET_REQUEST = "APPLICATION_LIST_GET_REQUEST";
export const APPLICATION_LIST_GET_SUCCESS = "APPLICATION_LIST_GET_SUCCESS";
export const APPLICATION_LIST_GET_ERROR = "APPLICATION_LIST_GET_ERROR";

export function get_applications(preventClearOnLoading = false) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/applications?CompleteApplications=true",
      authenticatedRequest: true,
      types: [
        APPLICATION_LIST_GET_REQUEST,
        APPLICATION_LIST_GET_SUCCESS,
        APPLICATION_LIST_GET_ERROR,
      ],
      additionalData: { preventClearOnLoading },
    },
  };
}
export const CREDIT_APPLICATION_LIST_GET_REQUEST =
  "CREDIT_APPLICATION_LIST_GET_REQUEST";
export const CREDIT_APPLICATION_LIST_GET_SUCCESS =
  "CREDIT_APPLICATION_LIST_GET_SUCCESS";
export const CREDIT_APPLICATION_LIST_GET_ERROR =
  "CREDIT_APPLICATION_LIST_GET_ERROR";
const creditApplicationDefaultTypes = [
  CREDIT_APPLICATION_LIST_GET_REQUEST,
  CREDIT_APPLICATION_LIST_GET_SUCCESS,
  CREDIT_APPLICATION_LIST_GET_ERROR,
];

export function get_credit_applications(
  borrowerId = null,
  onHold = false,
  notReviewed = true,
  expired = false,
  preventClearOnLoading = false,
  types = creditApplicationDefaultTypes,
) {
  let onHoldQueryParam = onHold != null ? "OnHold=" + onHold : "";
  let borrowerQueryParam =
    borrowerId != null ? "&BorrowerId=" + borrowerId : "";
  let notReviewedQueryParam =
    notReviewed != null ? "&WaitingForReview=" + notReviewed : "";
  let expiredQueryParam = expired != null ? "&Expired=" + expired : "";

  return {
    [CALL_API]: {
      endpoint:
        "/api/admin/credit-applications/list" +
        "?" +
        onHoldQueryParam +
        borrowerQueryParam +
        notReviewedQueryParam +
        expiredQueryParam,
      authenticatedRequest: true,
      types,
      additionalData: { preventClearOnLoading },
    },
  };
}

export const CREDIT_APPLICATION_APPROVE_REQUEST =
  "CREDIT_APPLICATION_APPROVE_REQUEST";
export const CREDIT_APPLICATION_APPROVE_SUCCESS =
  "CREDIT_APPLICATION_APPROVE_SUCCESS";
export const CREDIT_APPLICATION_APPROVE_ERROR =
  "CREDIT_APPLICATION_APPROVE_ERROR";

export function approve_credit_offer(offerId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/credit-application/approve",
      method: "POST",
      data: { OfferId: offerId },
      authenticatedRequest: true,
      types: [
        CREDIT_APPLICATION_APPROVE_REQUEST,
        CREDIT_APPLICATION_APPROVE_SUCCESS,
        CREDIT_APPLICATION_APPROVE_ERROR,
      ],
    },
  };
}

export const APPROVE_REJECT_THRESHOLD_REQUEST =
  "APPROVE_REJECT_THRESHOLD_REQUEST";
export const APPROVE_REJECT_THRESHOLD_SUCCESS =
  "APPROVE_REJECT_THRESHOLD_SUCCESS";
export const APPROVE_REJECT_THRESHOLD_ERROR = "APPROVE_REJECT_THRESHOLD_ERROR";

export function approve_reject_credit_offers(applicationId, maxApproveAmount) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/credit-application/approve-reject-loan-offers",
      method: "POST",
      data: {
        ApplicationId: applicationId,
        MaxApproveAmount: maxApproveAmount,
      },
      authenticatedRequest: true,
      types: [
        APPROVE_REJECT_THRESHOLD_REQUEST,
        APPROVE_REJECT_THRESHOLD_SUCCESS,
        APPROVE_REJECT_THRESHOLD_ERROR,
      ],
    },
  };
}

export const GET_KREDITZ_REPORT_GET_REQUEST = "GET_KREDITZ_REPORT_GET_REQUEST";
export const GET_KREDITZ_REPORT_GET_SUCCESS = "GET_KREDITZ_REPORT_GET_SUCCESS";
export const GET_KREDITZ_REPORT_GET_ERROR = "GET_KREDITZ_REPORT_GET_ERROR";

export function get_kreditz_report(autoReviewId) {
  return {
    [CALL_API]: {
      endpoint:
        "/api/admin/applications/get-kreditz-report?autoReviewId=" +
        autoReviewId,
      method: "GET",
      authenticatedRequest: true,
      types: [
        GET_KREDITZ_REPORT_GET_REQUEST,
        GET_KREDITZ_REPORT_GET_SUCCESS,
        GET_KREDITZ_REPORT_GET_ERROR,
      ],
      additionalData: { autoReviewId },
    },
  };
}

export const CREATE_KREDITZ_REVIEW_POST_REQUEST =
  "CREATE_KREDITZ_REVIEW_POST_REQUEST";
export const CREATE_KREDITZ_REVIEW_POST_SUCCESS =
  "CREATE_KREDITZ_REVIEW_POST_SUCCESS";
export const CREATE_KREDITZ_REVIEW_POST_ERROR =
  "CREATE_KREDITZ_REVIEW_POST_ERROR";

export function create_kreditz_review(applicationId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/applications/create-kreditz-review",
      method: "POST",
      data: {
        ApplicationId: applicationId,
      },
      authenticatedRequest: true,
      types: [
        CREATE_KREDITZ_REVIEW_POST_REQUEST,
        { method: createKreditzReviewSuccess },
        CREATE_KREDITZ_REVIEW_POST_ERROR,
      ],
    },
  };
}

function createKreditzReviewSuccess() {
  return (dispatch, getState) => {
    dispatch(get_applications(true));

    const state = getState();
    const userApps = state.userApplications.applications.data;

    if (userApps.length) {
      dispatch(
        get_applications_for_account(userApps[0].AccountId, [
          "",
          USER_APPLICATION_LIST_GET_SUCCESS,
          USER_APPLICATION_LIST_GET_ERROR,
        ]),
      );
    }
  };
}

export const CREATE_KREDITZ_REVIEW_CREDIT_POST_REQUEST =
  "CREATE_KREDITZ_CREDIT_REVIEW_POST_REQUEST";
export const CREATE_KREDITZ_REVIEW_CREDIT_POST_SUCCESS =
  "CREATE_KREDITZ_CREDIT_REVIEW_POST_SUCCESS";
export const CREATE_KREDITZ_REVIEW_CREDIT_POST_ERROR =
  "CREATE_KREDITZ_CREDIT_REVIEW_POST_ERROR";

export function create_kreditz_review_credit_app(applicationId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/credit-application/create-kreditz-review",
      method: "POST",
      data: {
        ApplicationId: applicationId,
      },
      authenticatedRequest: true,
      types: [
        CREATE_KREDITZ_REVIEW_CREDIT_POST_REQUEST,
        { method: createKreditzReviewCreditSuccess },
        CREATE_KREDITZ_REVIEW_CREDIT_POST_ERROR,
      ],
    },
  };
}

function createKreditzReviewCreditSuccess() {
  return (dispatch, response) => {
    dispatch(get_credit_applications());
    dispatch({ type: CREATE_KREDITZ_REVIEW_CREDIT_POST_SUCCESS, response });
  };
}

export const CREATE_CREDITSAFE_REPORT_REQUEST = "CREATE_BISNODE_REPORT_REQUEST";
export const CREATE_CREDITSAFE_REPORT_SUCCESS = "CREATE_BISNODE_REPORT_SUCCESS";
export const CREATE_CREDITSAFE_REPORT_ERROR = "CREATE_BISNODE_REPORT_ERROR";

export function create_creditsafe_report(applicationId, borrowerId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/credit-application/maybe-create-creditsafe-report",
      method: "POST",
      data: {
        ApplicationId: applicationId,
      },
      authenticatedRequest: true,
      types: [
        CREATE_CREDITSAFE_REPORT_REQUEST,
        {
          method: createCreditsafeReportSuccess.bind(
            this,
            applicationId,
            borrowerId,
          ),
        },
        CREATE_CREDITSAFE_REPORT_ERROR,
      ],
    },
  };
}

function createCreditsafeReportSuccess(applicationId, borrowerId, response) {
  return (dispatch) => {
    dispatch(get_credit_applications(borrowerId, false, true, false, true));
    dispatch({
      type: CREATE_CREDITSAFE_REPORT_SUCCESS,
      response,
      dataSend: { ApplicationId: applicationId },
    });
  };
}

export const PRE_APPLICATION_LIST_GET_REQUEST =
  "PRE_APPLICATION_LIST_GET_REQUEST";
export const PRE_APPLICATION_LIST_GET_SUCCESS =
  "PRE_APPLICATION_LIST_GET_SUCCESS";
export const PRE_APPLICATION_LIST_GET_ERROR = "PRE_APPLICATION_LIST_GET_ERROR";

export function get_pre_applications() {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/applications?CompleteApplications=false",
      authenticatedRequest: true,
      types: [
        PRE_APPLICATION_LIST_GET_REQUEST,
        PRE_APPLICATION_LIST_GET_SUCCESS,
        PRE_APPLICATION_LIST_GET_ERROR,
      ],
    },
  };
}

export const APPLICATION_UNDER_REVIEW_LIST_GET_REQUEST =
  "APPLICATION_UNDER_REVIEW_LIST_GET_REQUEST";
export const APPLICATION_UNDER_REVIEW_LIST_GET_SUCCESS =
  "APPLICATION_UNDER_REVIEW_LIST_GET_SUCCESS";
export const APPLICATION_UNDER_REVIEW_LIST_GET_ERROR =
  "APPLICATION_UNDER_REVIEW_LIST_GET_ERROR";

export function get_reviewing_applications() {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/applications/awaitingcompletion",
      authenticatedRequest: true,
      types: [
        APPLICATION_UNDER_REVIEW_LIST_GET_REQUEST,
        APPLICATION_UNDER_REVIEW_LIST_GET_SUCCESS,
        APPLICATION_UNDER_REVIEW_LIST_GET_ERROR,
      ],
    },
  };
}

export const APPLICATION_LIST_CHANGE_PAGE = "APPLICATION_LIST_CHANGE_PAGE";

export function change_application_list_page(page) {
  return {
    type: APPLICATION_LIST_CHANGE_PAGE,
    page,
  };
}

export const APPLICATION_LIST_CHANGE_FILTER = "APPLICATION_LIST_CHANGE_FILTER";

export function change_application_list_filter(key, value) {
  let filter = {};
  filter[key] = value;

  return {
    type: APPLICATION_LIST_CHANGE_FILTER,
    filter,
  };
}

export const PRE_APPLICATION_LIST_CHANGE_PAGE =
  "PRE_APPLICATION_LIST_CHANGE_PAGE";

export function change_pre_application_list_page(page) {
  return {
    type: PRE_APPLICATION_LIST_CHANGE_PAGE,
    page,
  };
}

export const PRE_APPLICATION_LIST_CHANGE_FILTER =
  "PRE_APPLICATION_LIST_CHANGE_FILTER";

export function change_pre_application_list_filter(key, value) {
  let filter = {};
  filter[key] = value;

  return {
    type: PRE_APPLICATION_LIST_CHANGE_FILTER,
    filter,
  };
}

export const APPLICATION_ON_HOLD_LIST_CHANGE_PAGE =
  "APPLICATION_ON_HOLD_LIST_CHANGE_PAGE";

export function change_application_on_hold_list_page(page) {
  return {
    type: APPLICATION_ON_HOLD_LIST_CHANGE_PAGE,
    page,
  };
}

export const APPLICATION_ON_HOLD_LIST_CHANGE_FILTER =
  "APPLICATION_ON_HOLD_LIST_CHANGE_FILTER";

export function change_application_on_hold_list_filter(key, value) {
  let filter = {};
  filter[key] = value;

  return {
    type: APPLICATION_ON_HOLD_LIST_CHANGE_FILTER,
    filter,
  };
}

export const APPLICATION_APPROVE_REQUEST = "APPLICATION_APPROVE_REQUEST";
export const APPLICATION_APPROVE_SUCCESS = "APPLICATION_APPROVE_SUCCESS";
export const APPLICATION_APPROVE_ERROR = "APPLICATION_APPROVE_ERROR";

export function approve_application(applicationId, offerId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/applications/approve",
      method: "POST",
      data: { ApplicationId: applicationId, OfferId: offerId },
      authenticatedRequest: true,
      types: [
        APPLICATION_APPROVE_REQUEST,
        APPLICATION_APPROVE_SUCCESS,
        APPLICATION_APPROVE_ERROR,
      ],
    },
  };
}

export const APPLICATION_REJECT_REQUEST = "APPLICATION_REJECT_REQUEST";
export const APPLICATION_REJECT_SUCCESS = "APPLICATION_REJECT_SUCCESS";
export const APPLICATION_REJECT_ERROR = "APPLICATION_REJECT_ERROR";

export function reject_application(applicationId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/applications/reject",
      method: "POST",
      data: { ApplicationId: applicationId },
      authenticatedRequest: true,
      types: [
        APPLICATION_REJECT_REQUEST,
        APPLICATION_REJECT_SUCCESS,
        APPLICATION_REJECT_ERROR,
      ],
    },
  };
}

export const TRANSFER_TO_REVIEW_REQUEST = "TRANSFER_TO_REVIEW_REQUEST";
export const TRANSFER_TO_REVIEW_SUCCESS = "TRANSFER_TO_REVIEW_SUCCESS";
export const TRANSFER_TO_REVIEW_ERROR = "TRANSFER_TO_REVIEW_ERROR";

export function transfer_to_review(applicationId, reason) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/applications/onhold",
      method: "POST",
      data: { ApplicationId: applicationId, Reason: reason },
      authenticatedRequest: true,
      types: [
        TRANSFER_TO_REVIEW_REQUEST,
        TRANSFER_TO_REVIEW_SUCCESS,
        TRANSFER_TO_REVIEW_ERROR,
      ],
    },
  };
}

export const PUT_APPLICATION_ON_HOLD_REQUEST =
  "PUT_APPLICATION_ON_HOLD_REQUEST";
export const PUT_APPLICATION_ON_HOLD_SUCCESS =
  "PUT_APPLICATION_ON_HOLD_SUCCESS";
export const PUT_APPLICATION_ON_HOLD_ERROR = "PUT_APPLICATION_ON_HOLD_ERROR";

export function put_application_on_hold(applicationId, onHold) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/credit-application/set-on-hold",
      method: "POST",
      data: { ApplicationId: applicationId, OnHold: onHold },
      authenticatedRequest: true,
      types: [
        PUT_APPLICATION_ON_HOLD_REQUEST,
        {
          method: RefreshCreditApplicationList.bind(
            this,
            PUT_APPLICATION_ON_HOLD_SUCCESS,
          ),
        },
        PUT_APPLICATION_ON_HOLD_ERROR,
      ],
    },
  };
}

function RefreshCreditApplicationList(type, response) {
  return (dispatch) => {
    dispatch({ type: type, response });
    dispatch(get_credit_applications(null, null));
  };
}

export const AUTO_REVIEW_REQUEST = "AUTO_REVIEW_REQUEST";
export const AUTO_REVIEW_SUCCESS = "AUTO_REVIEW_SUCCESS";
export const AUTO_REVIEW_ERROR = "AUTO_REVIEW_ERROR";

export function auto_review(applicationId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/applications/auto-review",
      method: "POST",
      data: { ApplicationId: applicationId },
      authenticatedRequest: true,
      types: [
        AUTO_REVIEW_REQUEST,
        { method: auto_review_succeeded.bind(this, applicationId) },
        AUTO_REVIEW_ERROR,
      ],
    },
  };
}

export const AUTO_REVIEW_FETCH_REQUEST = "AUTO_REVIEW_FETCH_REQUEST";
export const AUTO_REVIEW_FETCH_SUCCESS = "AUTO_REVIEW_FETCH_SUCCESS";
export const AUTO_REVIEW_FETCH_ERROR = "AUTO_REVIEW_FETCH_ERROR";

function auto_review_succeeded(applicationId, response) {
  return (dispatch) => {
    dispatch({ type: AUTO_REVIEW_SUCCESS, response });
    dispatch(fetch_auto_review(applicationId, response));
  };
}

function fetch_auto_review(applicationId, response) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/applications/get-auto-review?id=" + response,
      method: "GET",
      additionalData: { applicationId },
      authenticatedRequest: true,
      types: [
        AUTO_REVIEW_FETCH_REQUEST,
        AUTO_REVIEW_FETCH_SUCCESS,
        AUTO_REVIEW_FETCH_ERROR,
      ],
    },
  };
}

export const APPLICATION_NOMINAL_OFFER_REQUEST =
  "APPLICATION_NOMINAL_OFFER_REQUEST";
export const APPLICATION_NOMINAL_OFFER_SUCCESS =
  "APPLICATION_NOMINAL_OFFER_SUCCESS";
export const APPLICATION_NOMINAL_OFFER_ERROR =
  "APPLICATION_NOMINAL_OFFER_ERROR";

export function set_nominal_offer(postData) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/applications/offer/nominalbased",
      method: "POST",
      data: postData,
      authenticatedRequest: true,
      types: [
        APPLICATION_NOMINAL_OFFER_REQUEST,
        APPLICATION_NOMINAL_OFFER_SUCCESS,
        APPLICATION_NOMINAL_OFFER_ERROR,
      ],
    },
  };
}

export const APPLICATION_RISK_OFFER_REQUEST = "APPLICATION_RISK_OFFER_REQUEST";
export const APPLICATION_RISK_OFFER_SUCCESS = "APPLICATION_RISK_OFFER_SUCCESS";
export const APPLICATION_RISK_OFFER_ERROR = "APPLICATION_RISK_OFFER_ERROR";

export function set_risk_offer(postData) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/applications/offer/riskbased",
      method: "POST",
      data: postData,
      authenticatedRequest: true,
      types: [
        APPLICATION_RISK_OFFER_REQUEST,
        APPLICATION_RISK_OFFER_SUCCESS,
        APPLICATION_RISK_OFFER_ERROR,
      ],
    },
  };
}

export const EXPANDED_DATA_BISNODE_REQUEST = "EXPANDED_DATA_BISNODE_REQUEST";
export const EXPANDED_DATA_BISNODE_SUCCESS = "EXPANDED_DATA_BISNODE_SUCCESS";
export const EXPANDED_DATA_BISNODE_ERROR = "EXPANDED_DATA_BISNODE_ERROR";
// This is legacy, it is not used in the new flow
export function get_row_additional_data_bisnode(accountId, Id) {
  let endpoint = "/api/admin/creditreport/creditsafe?accountId=" + accountId;

  return {
    [CALL_API]: {
      endpoint: endpoint,
      authenticatedRequest: true,
      data: { accountId },
      correlation: { Id },
      types: [
        EXPANDED_DATA_BISNODE_REQUEST,
        EXPANDED_DATA_BISNODE_SUCCESS,
        EXPANDED_DATA_BISNODE_ERROR,
      ],
    },
  };
}

//ToDo: remove when we have implemented termination
export const SWAP_APPLICATION_DATA = "SWAP_APPLICATION_DATA";

export function swap_data() {
  return {
    type: SWAP_APPLICATION_DATA,
  };
}

export const REBUILD_PENDING_APPLICATIONS_REQUEST =
  "REBUILD_PENDING_APPLICATIONS_REQUEST";
export const REBUILD_PENDING_APPLICATIONS_SUCCESS =
  "REBUILD_PENDING_APPLICATIONS_SUCCESS";
export const REBUILD_PENDING_APPLICATIONS_ERROR =
  "REBUILD_PENDING_APPLICATIONS_ERROR";

export function rebuild_pending_applications() {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/applications/pending/refresh",
      authenticatedRequest: true,
      method: "POST",
      types: [
        REBUILD_PENDING_APPLICATIONS_REQUEST,
        REBUILD_PENDING_APPLICATIONS_SUCCESS,
        REBUILD_PENDING_APPLICATIONS_ERROR,
      ],
    },
  };
}

export const USER_APPLICATION_LIST_GET_REQUEST =
  "USER_APPLICATION_LIST_GET_REQUEST";
export const USER_APPLICATION_LIST_GET_SUCCESS =
  "USER_APPLICATION_LIST_GET_SUCCESS";
export const USER_APPLICATION_LIST_GET_ERROR =
  "USER_APPLICATION_LIST_GET_ERROR";
const appHistoryListActionTypes = [
  USER_APPLICATION_LIST_GET_REQUEST,
  { method: applications_for_account_get_success },
  USER_APPLICATION_LIST_GET_ERROR,
];

export function get_applications_for_account(
  accountId,
  types = appHistoryListActionTypes,
) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/applications/byaccount?Id=" + accountId,
      authenticatedRequest: true,
      types,
    },
  };
}

function applications_for_account_get_success(response) {
  return (dispatch) => {
    dispatch({
      type: USER_APPLICATION_LIST_GET_SUCCESS,
      response,
    });
  };
}
